<template>
  <div class="v-web-footer">
    <div class="foot-content">
      <div class="content_menu">
        <div class="left_shadow">
          <div class="foot_logo">
            <img src="../assets/images/index/foot_logo.png"/>
          </div>
          <div class="left_content_info">
            <div class="content_info">
              <div class="info_detail">
                <span class="icon iconfont icondizhi iconclass"></span>
                <div class="text">
                  <div>{{$t('footText.address_prefix1')}}</div>
                  <!-- <div>{{$t('footText.address_suffix')}}</div> -->
                </div>
              </div>
              <div class="info_detail">
                <span class="icon iconfont icondianhua1 iconclass"></span>
                <div class="text"><span>{{$t('footText.phone')}}</span></div>
              </div>
              <div class="info_detail">
                <span class="icon iconfont iconyoujian iconclass"></span>
                <div class="text"><span>{{$t('footText.email')}}</span></div>
              </div>
            </div>
            <div class="weixin">
              <img src="../assets/images/index/weixin.png" class="weixin_img"/>
              <div class="weixin_span">{{$t("footText.weixin")}}</div>
            </div>
          </div>
        </div>
        <div class="right_content" :class="this.$i18n.locale=='en-US'?'right_content_special':''">
          <div class="item_content about-us" :class="this.$i18n.locale=='en-US'?'item_content_special':''">
            <div class="menu_title">{{$t('footText.aboutUs')}}</div>
            <div class="menu_content">
              <a href="/#/about?to=id_company_info" @click='reloadHref("/#/about?to=id_company_info")' class="menu_item">{{$t('footText.company')}}</a>
              <a href="/#/home?to=id_honor"  @click='reloadHref("/#/home?to=id_honor")' class="menu_item">{{$t('footText.honor')}}</a>
              <a href="/#/home?to=id_technology" @click='reloadHref("/#/home?to=id_technology")' class="menu_item">{{$t('footText.technology')}}</a>
              <a href="/#/about?to=id_team" @click='reloadHref("/#/about?to=id_team")' class="menu_item">{{$t('footText.team')}}</a>
            </div>
          </div>
          <div class="item_content services" :class="this.$i18n.locale=='en-US'?'item_content_special':''">
            <div class="menu_title">{{$t('footText.services')}}</div>
            <div class="menu_content">
              <a href="/#/yDNATest" class="menu_item">{{$t('footText.chromosomeText')}}</a>
              <a href="/#/nPrenatalTest" class="menu_item">{{$t('footText.invasivePrenatalTest')}}</a>
              <a href="/#/paternityTest" class="menu_item" v-if="$store.state.lang!='en-US'">{{$t('footText.invasivePaterNityTest')}}</a>
              <a href="/#/paternityTest" class="menu_item" v-if="$store.state.lang=='en-US'">Paternity Test <br> (before birth or after birth)</a>
              <!-- <div class="menu_item">{{$t('footText.special')}}</div> -->
            </div>
          </div>
          <div class="item_content news" :class="this.$i18n.locale=='en-US'?'item_content_special':''">
            <div class="menu_title">{{$t('footText.news')}}</div>
            <div class="menu_content">
              <a href="/#/Notices" class="menu_item">{{$t('footText.notice')}}</a>
              <a href="/#/MediaCenter" class="menu_item">{{$t('footText.mediaCentre')}}</a>
              <a href="/#/search" class="menu_item">{{$t('footText.report')}}</a>
            </div>
          </div>
          <div class="item_content office-hours" :class="this.$i18n.locale=='en-US'?'item_content_special':''">
            <div class="menu_title">{{$t('footText.OfficeHours')}}</div>
            <div class="menu_content">
              <div class="menu_item">
                <div class="day">{{$t('footText.day1')}}</div>
                <div class="time" :class="this.$i18n.locale=='en-US'?'time_special':''">
                  <div>09:30 – 13:00</div>
                  <div>14:30 – 18:00</div>
                </div>
              </div>
              <div class="menu_item">
                <div class="day">{{$t('footText.day2')}}</div>
                <div class="time" :class="this.$i18n.locale=='en-US'?'time_special':''">
                  <div>09:30 – 13:00</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot-bottom-content">
      <div class="version">{{$t('footText.version')}}</div>
      <div class="href">
        <a target="_blank" href="/static/香港醫務檢測中心有限公司私隱政策.pdf">{{$t('footText.privacy')}}</a>
        /
        <a target="_blank" href="/static/香港醫務檢測中心有限公司使用條款.pdf">{{$t('footText.terms')}}</a>
      </div>
      <!-- <div class="href">
        <a target="_blank" href="http://www.hhlink.com">{{$t('footText.Links1')}}</a>
      </div> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: "web-footer",
    data() {
      return {}
    },
    methods: {
      reloadHref(href){
        let index = href.indexOf('?'); // -1
        let path = href.substring(0, index);

        //相同页面. 强制刷新
        if (location.href.indexOf(path) !== -1) {
          location.href = href;
          location.reload();
        }else{
          location.href = href;
        }
      },
      liJump(path) {
        this.$router.push({
          path: path
        })
      }
    },
  }
</script>

<style scoped lang="scss">

  .en .v-web-footer {
    .foot-content {
      .content_menu {

        .left_shadow{
          .left_content_info{
            .weixin{
              .weixin_span{
                transform: scale(.8);
                padding-right: .15vw;
              }
            }
          }
        }
        .right_content {
          .item_content {
            .menu_content {
              .menu_item {
                .day {
                  width: 7vw;
                }
              }
            }
          }
        }
      }
    }
  }
</style>

<style scoped lang="scss">
  .v-web-footer {
    color: #000000;
    background-color: #f8fafc;

    .foot-content {
      width: 100%;
      /*background: url('/static/images/double helix-65.png') no-repeat;*/
      position: relative;
      background-size: cover;

      .content_menu {
        padding: 3vw 0;
        display: flex;

        .left_shadow {
          width: 18vw;
          min-width: 290px;
          margin-left: 9vw;
          display: flex;
          flex-direction: column;
          justify-content: left;

          .foot_logo {
            width: 100%;
            height: 3.13vw;

            img {
              width: 100%;
              height: auto;
            }
          }

          .left_content_info {
            margin-top: 1vw;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .content_info {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              padding-top: .15vw;

              .info_detail {
                text-align: left;
                display: flex;
                flex-direction: row;
                font-size: 0.83vw;
                line-height: 1.23vw;
                margin-bottom: .8vw;
                cursor: pointer;

                .icon {
                  font-size: 1vw;
                  padding-top: .15vw;
                  margin-right: .3vw;
                }
              }
            }

            .weixin {
              margin-left: .5vw;
              width: 5.5vw;
              min-width: 95px;
              font-size: 0.70vw;
              flex-shrink: 0;

              .weixin_img {
                width: 100%;
                height: 100%;;
              }

              .weixin_span {
                white-space: nowrap;
                text-align: center;
                line-height: 20px;
                cursor: pointer;
              }
            }
          }
        }

        .right_content {
          height: 100%;
          flex-grow: 1;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-direction: row;
          margin-left: 5vw;
          margin-top: 0.6vw;

          .item_content {
            width: 14vw;

            &.office-hours {
              flex-grow: 1;
            }

            .menu_title {
              font-size: 1.04vw;
              line-height: 18px;
              font-weight: bold;

              display: flex;

              padding: 0 0 0.83vw;
              border-bottom: 4px solid #36a4b2;
            }

            .menu_content {
              display: flex;
              flex-direction: column;
              margin-top: .57vw;

              .menu_item {
                font-size: 0.83vw;
                color: #252526;
                margin-bottom: 11px;
                cursor: pointer;
                text-align: left;
                display: flex;

                .day {
                  font-size: 0.8vw;
                  width: 4vw;
                }

                .time {
                  margin-left: 28px;
                  font-size: 0.8vw;
                }

                .time_special {
                  margin-left: 18px !important;
                }
              }

              .menu_item:hover {
                color: #1bb89d;
              }
            }
          }
        }
      }

    }

    .foot-bottom-content {
      width: 100%;
      text-align: center;
      padding: 12px;
      background-image: -ms-linear-gradient(left, #1DB9A0 0%, #4d94c4 100%);
      background-image: -moz-linear-gradient(left, #1DB9A0 0%, #4d94c4 100%);
      background-image: -o-linear-gradient(left, #1DB9A0 0%, #4d94c4 100%);
      background-image: -webkit-gradient(linear, left top, right top, color-stop(0, #1DB9A0), color-stop(100, #4d94c4));
      background-image: -webkit-linear-gradient(left, #1DB9A0 0%, #4d94c4 100%);
      background-image: linear-gradient(to right, #1DB9A0 0%, #4d94c4 100%);

      cursor: pointer;
      font-size: 12px;
      line-height: 18px;
      color: #ffffff;
      .version {

      }
      .href{
        a{
          color: #ffffff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/web-footer.vue